export const EXISTING_CSV_FIELDS = {
	RESERVE_PRICE: 'Reserve price',
};

export const BULK_BIDDING_CSV_FIELDS = {
	BID_AMOUNT: 'Bid amount',
	FEE_AT_RESERVE_PRICE: 'Fee at reserve price',
	VEHICLE_LINK: 'Motorway vehicle link',
} as const;

export const LINK_WITH_ENQUIRY_ID_REGEX = /^https:\/\/(?:stage-pro|pro)\.motorway\.co\.uk\/vehicles\/\d+$/;
